import { ClientConfig, DEFAULT_CLIENT_CONFIG } from './config.base';
import { navigationRoutes as BaseLinks, RouteParams } from './links.base';

export const CLIENT_CONFIG: ClientConfig = {
  clientName: 'segmovil',
  ...DEFAULT_CLIENT_CONFIG,
  logo: {
    lightLogo: 'assets/segmovil/light-logo.svg',
    darkLogo: 'assets/segmovil/dark-logo.svg',
    alt: 'SegMovil',
    width: '65px',
    height: '65px',
    loginPageWidth: '100px',
    loginPageHeight: '100px',
  },
  showCustomLoginPage: true,
};

export const navigationRoutes: RouteParams[] = CLIENT_CONFIG.allowedRoutes.map((x) => BaseLinks[x]);
